export enum PlanManagementTaskStatusEnum {
  PENDING_FETCH = 'PENDING_FETCH',
  FAIL_FETCH = 'FAIL_FETCH',
  FAIL_SYNC = 'FAIL_SYNC',
  MIGRATING = 'MIGRATING',
  MIGRATE_FAILED = 'MIGRATE_FAILED',
  MIGRATED = 'MIGRATED',
  PENDING_COMPARE = 'PENDING_COMPARE',
  FAIL_COMPARE = 'FAIL_COMPARE',
  SUCCESS = 'SUCCESS',
}
